import { PageHero, Reveal, SectionHead, PhotoFrame, EmptyState, MaskedLine } from "@/components/Shared";
import { useCollection, usePageContent, IMG } from "@/lib/api";
import { PAGES } from "@/content/pageContent";

export default function Legacy() {
  const { items, loading } = useCollection("legacy");
  const c = usePageContent("legacy", PAGES.legacy.defaults);

  return (
    <main>
      <PageHero eyebrow="Alumni · Past Presidents" title="Our" italic="Legacy" image="/legacy_sword.jpg">
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          {c.heroText}
        </p>
      </PageHero>

      <section className="relative overflow-hidden py-24" data-testid="legacy-timeline">
        <div className="pointer-events-none absolute inset-0">
          <img src={IMG.celestialSky} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink via-transparent to-ink" />
        </div>
        <div className="relative z-10 mx-auto max-w-6xl px-6">
        <SectionHead eyebrow="The Flame Keepers" title="Presidents of" italic="RCSCW" align="center" />
        {loading && <p className="mt-12 text-center text-sm text-silver-muted">Loading legacy…</p>}

        <div className="relative mt-20">
          <div className="absolute left-4 top-0 h-full w-px bg-gradient-to-b from-ember/70 via-silver/20 to-silver/5 sm:left-1/2" />
          {(items || []).map((l, i) => (
            <Reveal key={l.id} delay={0.04}>
              <div className={`relative mb-14 pl-12 sm:w-1/2 sm:pl-0 ${i % 2 === 0 ? "sm:pr-16 sm:text-right" : "sm:ml-auto sm:pl-16"}`} data-testid={`legacy-entry-${i}`}>
                <span className={`absolute top-3 h-3.5 w-3.5 rotate-45 border border-ember bg-ink left-2 ${i % 2 === 0 ? "sm:left-auto sm:-right-2" : "sm:-left-2"}`} />
                <p className="font-mono text-sm tracking-[0.3em] text-ember">{l.years}</p>
                <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center" style={i % 2 === 0 ? { flexDirection: "row-reverse" } : {}}>
                  <PhotoFrame src={l.photo} label={`${l.years} president`} className="h-24 w-24 shrink-0 sm:h-28 sm:w-28" />
                  <div className={i % 2 === 0 ? "sm:text-right" : ""}>
                    <h3 className="font-display text-2xl font-semibold text-silver">{l.president}</h3>
                    {l.note && <p className="mt-2 text-xs leading-relaxed text-silver-muted">{l.note}</p>}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {!loading && (items || []).length === 0 && (
          <div className="mt-12">
            <EmptyState title="The legacy is being written" note="Past presidents will be added by the club via the Admin panel." />
          </div>
        )}

        <MaskedLine>
          <div className="mt-8 border-t border-silver/10 pt-16 text-center">
            <p className="eyebrow">And now</p>
            <p className="mt-4 font-display text-4xl font-semibold">
              <span className="text-silver">{c.closingYear}</span>
              <em className="metallic">{c.closingTheme}</em>
            </p>
            <p className="mx-auto mt-4 max-w-md text-sm text-silver-muted">
              {c.closingNote}
            </p>
          </div>
        </MaskedLine>
        </div>
      </section>
    </main>
  );
}
